export default __webpack_public_path__ + "static/media/mechanical.f5d37a95.png";